import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from 'i18next-http-backend';
import en from "./assets/locales/en/translation.json"
import vi from "./assets/locales/vi/translation.json"

const resources = {
    en: {
        translation: en
    },
    vi: {
        translation: vi
    }
}

let lang = null;

if (typeof window.localStorage === "object" && typeof window.localStorage?.getItem !== 'undefined') {
    lang = localStorage.getItem("i18nextLng");
}

if (!lang) {
    lang = "en"
    if (typeof window.localStorage === "object" && typeof window.localStorage?.getItem !== 'undefined') {
        localStorage.setItem("i18nextLng", lang)
    }
    else {
        console.error("localStorage is not available");
    }
}

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
        // debug : true,
        fallbackLng: "vi",
        resources,
        detection: {
            order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage']
        },
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    })

export default i18n;

